export default __webpack_public_path__ + "static/media/card_sample.a8e8deb1.png";